import React, {useRef} from 'react'


import './Login.css'


const Users = () => {
    const emailValue = useRef()

    const RemoveUserHandler = async event => {
        event.preventDefault()

        const enteredEmail = emailValue.current.value 

        const requestBody = {
            email: enteredEmail,
          };

          await fetch(process.env.REACT_APP_BACKEND_URL + '/user/remove',{
             method: "DELETE",
             headers: {
                 'Content-Type': 'application/json',
             },
             body: JSON.stringify(requestBody),
         }
         ).then(response => {
 
             if (!response.ok) {
                 throw new Error(`Invalid user`+ requestBody.email);
             } 
             alert("User has been removed successfully");
         })
         .then(data => { 
             console.log(data)       
         })
         .catch(error => console.error(error));
        }
    
    return (
        <form onSubmit={RemoveUserHandler}>
            <div className='container'>
                <div className='header'>
                    <div className='text'>Remove User</div>
                </div>
                <div className='inputs'>
                    <div className='input'>
                        <img src='' alt='' />
                        <input type='email' placeholder='Email' ref={emailValue} />
                    </div>
                </div>
                <div className='submit-container'>
                    <div className='submit' onClick={RemoveUserHandler}>DELETE</div>
                </div>
            </div>
        </form>
    )
}

export default Users